const getters = {
    paginationTypes: (state) => state.paginationTypes,
    purchasesTypes: (state) => state.purchasesTypes,
    placesTypes: (state) => state.placesTypes,
    lineHeightsTypes: (state) => state.lineHeightsTypes,
    subscriptionStatusesTypes: (state) => state.subscriptionStatusesTypes,
    sectorsTypes: (state) => state.sectorsTypes,
}

export default getters